import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { PericiaAfastamentoService } from '../../../../folha-pagamento/src/common/services/pericia-afastamento.service';
import { PericiaAfastamento } from '../../../../folha-pagamento/src/common/components/pericia-afastamento/pericia-afastamento';

@Injectable()
export class PortalPericiaAfastamentoService extends PericiaAfastamentoService {

  private readonly resourcePortal: string = '/api/portal-servidor/pericia-afastamento';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public findOneByMovimentacaoId(movimentacaoId: number): Observable<PericiaAfastamento> {
    return this.httpClient.get({
      resource: `${this.resourcePortal}/movimentacao/${movimentacaoId}`,
      disableSpinner: true
    });
  }
}
